/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { Canvg } from 'canvg';
import { isChrome } from '@insights-ltd/design-library/utils';
import {
  canvasToBlob,
  getSvgElementById,
  renderCanvasToBlob,
  svgDataCanvasAndContextFromSvgElement,
} from 'pages/DownloadTeamWheel/globalMethods';

const renderSVGToBlob = (
  svgId: string,
  forceNativeInChrome = false,
  setWidth?: number,
  setHeight?: number,
): Promise<Blob> =>
  new Promise<Blob>((resolve, reject) => {
    const $svg = getSvgElementById(svgId);
    if (!$svg) {
      reject(new Error('Invalid svgId!'));
      return;
    }
    const width = setWidth || $svg.getBoundingClientRect().width * 2;
    const height = setHeight || $svg.getBoundingClientRect().height * 2;
    const { canvas, ctx, svgData } = svgDataCanvasAndContextFromSvgElement(
      $svg,
      width,
      height,
    );
    if (isChrome() && !forceNativeInChrome) {
      const v = Canvg.fromString(ctx!, svgData);
      v.render()
        .then(() => {
          if (isChrome()) {
            canvasToBlob(canvas)
              .catch((error) => reject(error))
              .then((blob) => resolve(blob as Blob));
          }
        })
        .catch((error) => reject(error));
    } else {
      renderCanvasToBlob(svgData, ctx!, canvas, width, height)
        .catch((error) => reject(error))
        .then((blob) => resolve(blob as Blob));
    }
  });

export default renderSVGToBlob;
/* eslint-enable @typescript-eslint/no-non-null-assertion */
